import { Component, Inject, PLATFORM_ID, ChangeDetectorRef, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NbRegisterComponent, NbAuthService, NbAuthResult } from '@nebular/auth';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { FirebaseAuthStrategy } from '../firebase-auth-strategy';

@Component({
  selector: 'ngx-custom-register',
  templateUrl: './custom-register.component.html',
  styleUrls: ['./custom-register.component.scss'],
    encapsulation: ViewEncapsulation.None,

})
export class CustomRegisterComponent extends NbRegisterComponent implements OnInit,OnDestroy {

  // Custom UI variables
  showPassword = false;
  showConfirmPassword = false;
  isDark = false;

  // Slideshow images
  images = [
    'assets/images/1.webp',
    'assets/images/6.webp',
    'assets/images/2.webp',
    'assets/images/3.webp',
    'assets/images/4.webp',
    'assets/images/5.webp',
  ];
  activeIndex = 0;
  slideInterval: any;

  constructor(
    protected service: NbAuthService,
    protected cd: ChangeDetectorRef,
    protected router: Router,
    protected firebaseAuth: FirebaseAuthStrategy,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super(service, {}, cd, router);

    // Overwrite Nebular default user object
this.user = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  terms: false,
};

  }

  // ---------------------------------------------
  //  ON INIT → ALSO START SLIDESHOW + THEME
  // ---------------------------------------------
 ngOnInit(): void {


    this.startSlideshow();
  }

ngOnDestroy(): void {
    if (this.slideInterval) clearInterval(this.slideInterval);
  }

  // ---------------------------------------------
  //  NEBULAR REGISTER (FULL LOGIC INSIDE)
  // ---------------------------------------------
  override register(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;
if (!this.user.firstName) {
  this.errors.push('First name is required');
  this.submitted = false;
  return;
}

    // Custom validation (you can modify)
    if (this.user.password !== this.user.confirmPassword) {
      this.errors.push('Passwords do not match');
      this.submitted = false;
      return;
    }

const fullName = `${this.user.firstName} ${this.user.lastName}`.trim();

const data = {
  fullName,
  email: this.user.email,
  password: this.user.password,
};

this.firebaseAuth.register(data).subscribe((result: NbAuthResult) => {
  this.submitted = false;
  this.messages = result.getMessages();
  this.errors = result.getErrors();

  if (result.isSuccess()) {
    /*
     * Respect the strategy redirect. The first Super Admin must complete
     * profile upload, while normal users remain signed out and pending.
     */
    this.router.navigateByUrl(result.getRedirect() || '/');
  } else if (this.messages.includes('Pending approval')) {
    this.router.navigate(['/auth/login']);
  }

  this.cd.detectChanges();
});
  }

  // ---------------------------------------------
  //  UI HELPERS
  // ---------------------------------------------
  togglePassword() { this.showPassword = !this.showPassword; }
  toggleConfirmPassword() { this.showConfirmPassword = !this.showConfirmPassword; }

  // ---------------------------------------------
  //  THEME SYSTEM (SAME AS LOGIN)
  // ---------------------------------------------


  // ---------------------------------------------
  //  SLIDESHOW SYSTEM
  // ---------------------------------------------
  startSlideshow() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.slideInterval = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.images.length;
    }, 3000);
  }
}
